module.exports = __webpack_public_path__ + "img/3048620.8f6aa7e0.png";